export class BuildingTag {
  constructor() {
    this.id = "";
    this.description = "";
    this.createdBy = "";
  }
}
